module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-pages",
    style: ({
      backgroundImage: 'url(' + _vm.props.bg_img + ')'
    })
  }, [_c('div', {
    staticClass: "hero-pages__overlay"
  }), _c('div', {
    staticClass: "hero-pages__container"
  }, [_vm._l((_vm.array), function(title, a) {
    return (title.path === _vm.$route.fullPath) ? _c('div', {
      staticClass: "hero-pages__title"
    }, [_vm._v(_vm._s(title.name))]) : _vm._e()
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.route.hash === "#office-tour-bloomingdale" || _vm.$store.state.route.hash === "#office-tour-naperville" || _vm.$store.state.route.hash === "#office-tour-chicago"),
      expression: "$store.state.route.hash === \"#office-tour-bloomingdale\" || $store.state.route.hash === \"#office-tour-naperville\" || $store.state.route.hash === \"#office-tour-chicago\""
    }],
    staticClass: "hero-pages__title herotitlenew"
  }, [_c('router-link', {
    attrs: {
      "to": "/our-practice#office-tour-bloomingdale"
    }
  }, [_vm._v("Office Tour Bloomingdale")]), _c('router-link', {
    attrs: {
      "to": "/our-practice#office-tour-naperville"
    }
  }, [_vm._v("Office Tour Naperville")])], 1), _c('div', {
    staticClass: "hero-pages__subnav"
  }, _vm._l((_vm.array), function(link, b) {
    return _c('span', {
      staticClass: "hero-pages__link-container"
    }, [(link.path === "#") ? _c('router-link', {
      key: b,
      staticClass: "hero-pages__link",
      attrs: {
        "to": "#office-tour-bloomingdale"
      }
    }, [_c('span', [_vm._v(_vm._s(link.name))])]) : _c('router-link', {
      key: b,
      staticClass: "hero-pages__link",
      attrs: {
        "to": link.path
      }
    }, [_c('span', [_vm._v(_vm._s(link.name))])])], 1)
  }), 0)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60267aa9","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/hero/hero-pages/hero-pages.pug
// module id = 699
// module chunks = 1